import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import noop from '@gik/core/utils/noop';

export interface TabDefinition {
  title: string;
  content: React.ReactNode;
}

export interface ITabbedViewProps {
  tabs: TabDefinition[];
  className?: string;
  onChangeTab?: (selectedTab: TabDefinition, selectedTabIndex: number) => void;
  selectedTab?: number;
}

const blockName = 'tabbed-view';

export default function TabbedView({ tabs, className, onChangeTab = noop, selectedTab }: ITabbedViewProps) {
  const [internalSelectedTab, setInternalSelectedTab] = React.useState<number>(0);
  const bem = bemBlock(blockName);

  const handleChangeTab = (activeTab: number) => {
    setInternalSelectedTab(activeTab);
    onChangeTab(tabs[activeTab], activeTab);
  };

  const getSelectedTab = (): number => {
    if (selectedTab !== null && selectedTab !== undefined) {
      return selectedTab;
    } else {
      return internalSelectedTab;
    }
  };

  return (
    <div className={bem(null, null, className)}>
      <div className={bem('tabs-wrapper')}>
        <div className={bem('tabs-section')}>
          {tabs.map((tab, i) => (
            <section
              className={bem('tab', [
                {
                  selected: getSelectedTab() === i,
                },
              ])}
              onClick={() => handleChangeTab(i)}
              key={i}
            >
              {tab.title}
            </section>
          ))}
        </div>
        <div className={bem('tab-content')}>{tabs[getSelectedTab()].content}</div>
      </div>
    </div>
  );
}
